import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Tipo de Usuario',
        path: '/biblioteca/bibtipousuario',
        name: 'bibtipousuario',
        component: () => import('@/views/biblioteca/bibtipousuario/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_PARAMETROSUSUARIOSNOVO_MENU_1300300199],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Tipo de Usuário',
        path: '/biblioteca/bibtipousuario/cadastro/:id?',
        parent: 'bibtipousuario',
        name: 'bibtipousuario_create',
        component: () => import('@/views/biblioteca/bibtipousuario/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_PARAMETROSUSUARIOSNOVO_MENU_1300300199],
        },
        goesToMenu: true,
    },
]
